module.exports = __webpack_public_path__ + "img/6.a1b066db.png";